import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const InstantMonitor = lazy(() =>
    import('@/v1/management/views/InstantMonitor').then((module) => ({
        default: module.InstantMonitor,
    }))
);

const HistoryMonitor = lazy(() =>
    import('@/v1/management/views/HistoryMonitor').then((module) => ({
        default: module.HistoryMonitor,
    }))
);

const BusNetworkReboot = lazy(() =>
    import('@/v1/report/views/BusNetworkReboot').then((module) => ({
        default: module.BusNetworkReboot,
    }))
);

const QrReport = lazy(() =>
    import('@/v1/report/views/QrReport').then((module) => ({
        default: module.QrReport,
    }))
);

const AllQrReport = lazy(() =>
    import('@/v1/report/views/AllQrReport').then((module) => ({
        default: module.AllQrReport,
    }))
);

const AvailabilityRegression = lazy(() =>
    import('@/v1/report/views/AvailabilityRegression').then((module) => ({
        default: module.AvailabilityRegression,
    }))
);

const BvScheduledFirmwareVersion = lazy(() =>
    import('@/v1/management/views/BvScheduledFirmwareVersion').then(
        (module) => ({
            default: module.BvScheduledFirmwareVersion,
        })
    )
);

const VehicleRelease = lazy(() =>
    import('@/v1/management/views/VehicleRelease').then((module) => ({
        default: module.VehicleRelease,
    }))
);

const RestartDisconnectCount = lazy(() =>
    import('@/v1/management/views/RestartDisconnectCount').then((module) => ({
        default: module.RestartDisconnectCount,
    }))
);

const RoadNetwork = lazy(() =>
    import('@/v1/report/views/RoadNetwork').then((module) => ({
        default: module.RoadNetwork,
    }))
);

export const managementRoutes: RouteObject[] = [
    {
        path: `instant`,
        ...PageElement(<InstantMonitor />),
    },
    {
        path: `history`,
        ...PageElement(<HistoryMonitor />),
    },
    {
        path: `reboot_cnt`,
        ...PageElement(<BusNetworkReboot />),
    },
    {
        path: `qr_exception`,
        ...PageElement(<QrReport />),
    },
    {
        path: `avaliability`,
        ...PageElement(<AllQrReport />),
    },
    {
        path: `avaliability_regression`,
        ...PageElement(<AvailabilityRegression />),
    },
    {
        path: `bv_scheduled_firmware_version`,
        ...PageElement(<BvScheduledFirmwareVersion />),
    },
    {
        path: `vehiclerelease`,
        ...PageElement(<VehicleRelease />),
    },
    {
        path: `restartdisconnectcount`,
        ...PageElement(<RestartDisconnectCount />),
    },
    {
        path: `roadnetwork`,
        ...PageElement(<RoadNetwork />),
    },
];
